export default class Event {
  constructor() {
    this.container = {}
  }

  on(eventName, cb) {
    if (!this.container[eventName]) {
      this.container[eventName] = []
    }
    this.container[eventName].push(cb)
  }

  off(eventName, cb) {
    if (typeof cb === undefined) {
      this.container[eventName] = []
      return
    }
    this.container[eventName] = this.container[eventName].filter(item => item !== cb)
  }

  once(eventName, cb) {
    const handle = (...args) => {
      cb && cb(...args)
      this.off(eventName, handle)
    }
    this.on(eventName, handle)
  }

  emit(eventName, ...args) {
    const cbs = this.container[eventName]
    if (cbs) {
      cbs.forEach(cb => cb && cb(...args))
    }
  }
}